import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { clientApi } from '@/api/client'
import Loading from '@/components/Loading'
import ErrorBox from '@/components/ErrorBox'
import Topbar from '@/components/Topbar'

export default function Watchlists() {
  const [data, setData] = useState<any[] | null>(null)
  const [error, setError] = useState<any>(null)

  useEffect(() => {
    let cancelled = false
    clientApi.watchlists().then((x) => {
      if (cancelled) return
      setData(x)
    }).catch(setError)
    return () => { cancelled = true }
  }, [])

  if (!data && !error) return <div className="container"><Loading label="Loading watchlists" /></div>

  return (
    <div className="container">
      <Topbar subtitle="Watchlists" />

      <div className="grid">
        <div className="card">
          <h2>Your watchlists</h2>
          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                {(data || []).map((w) => (
                  <tr key={w.watchlist_id}>
                    <td>
                      <Link className="titleLink" to={`/watchlists/${w.watchlist_id}`}>{w.name}</Link>
                      <div className="muted">{w.description || ''}</div>
                      <div className="mono muted" style={{ marginTop: 6, fontSize: 12 }}>{w.watchlist_id}</div>
                    </td>
                    <td>{w.is_default ? <span className="pill ok">Default</span> : <span className="pill">-</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {error ? <ErrorBox error={error} /> : null}
      </div>
    </div>
  )
}
